import {
    GET_PRODUCTS,
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCTS_FAILED,

    SUBMIT_PRODUCT_FORM,
    SUBMIT_PRODUCT_FORM_SUCCESS,
    SUBMIT_PRODUCT_FORM_FAILED,

    DELETE_PRODUCT,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAILED,
} from '../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    products: [],
    submittingForm: false,
    error: null,
    deleting: false
};

const ProductReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PRODUCTS:
            return { ...state, loading: true };
        case GET_PRODUCTS_SUCCESS:
            return { ...state, products: action.payload.data, total: action.payload.total, loading: false, error: null };
        case GET_PRODUCTS_FAILED:
            return { ...state, error: action.payload, loading: false };

        case SUBMIT_PRODUCT_FORM:
            return { ...state, error: null, submittingForm: true };
        case SUBMIT_PRODUCT_FORM_SUCCESS:
            const alreadyExists = state.products.find((item) => item.id === action.payload.id);
            let products;
            let total = state.total;
            if (!alreadyExists) {
                products = [action.payload, ...state.products];
                total += 1;
            } else {
                products = state.products.map((item) => {
                if (item.id === action.payload.id) {
                  return action.payload;
                }
                return item;
              });
            }
            return { ...state, total,  products, submittingForm: false };
        case SUBMIT_PRODUCT_FORM_FAILED:
            return { ...state, error: action.payload, submittingForm: false };

        case DELETE_PRODUCT:
            return { ...state, error: null, deleting: true };
        case DELETE_PRODUCT_SUCCESS:
            return { ...state, total: state.total - 1, products: state.products.filter(item => item.id !== action.payload) , deleting: false };
        case DELETE_PRODUCT_FAILED:
            return { ...state, error: action.payload, deleting: false };
        default: return { ...state };
    }
}

export default ProductReducer;